import { OPItem } from "@/interfaces/CardItem";

import { getCardData } from "@/lib/games/onePiece/getCardDataLocal";

export function sortCards(a: OPItem, b: OPItem) {
  // cost
  if (b.cost !== a.cost) {
    let acost;
    let bcost;
    if (b.cost === undefined || b.cost === null) {
      if (b.type === "Leader") {
        bcost = -1;
      } else {
        bcost = 0;
      }
    } else {
      bcost = parseInt(b.cost.toString());
    }
    if (a.cost === undefined || a.cost === null) {
      if (a.type === "Leader") {
        acost = -1;
      } else {
        acost = 0;
      }
    } else {
      acost = parseInt(a.cost.toString());
    }
    // handle special cases where cost is "-" or 0
    if (acost - bcost !== 0) {
      return acost - bcost; // Compare as numbers
    }
  }

  // color
  if (b.color !== a.color) {
    const colorOrder: string[] = [
      "Red",
      "Red/Green",
      "Red/Blue",
      "Red/Purple",
      "Red/Black",
      "Red/Yellow",
      "Green",
      "Green/Blue",
      "Green/Purple",
      "Green/Black",
      "Green/Yellow",
      "Blue",
      "Blue/Purple",
      "Blue/Black",
      "Blue/Yellow",
      "Purple",
      "Purple/Black",
      "Purple/Yellow",
      "Black",
      "Black/Yellow",
      "Yellow",
    ];
    const colorAIndex = colorOrder.indexOf(a.color);
    const colorBIndex = colorOrder.indexOf(b.color);
    return colorAIndex - colorBIndex;
  }

  // type
  if (b.type !== a.type) {
    const typeOrder: string[] = ["Leader", "Character", "Event", "Stage"];
    const typeAIndex = typeOrder.indexOf(a.type);
    const typeBIndex = typeOrder.indexOf(b.type);
    return typeAIndex - typeBIndex;
  }

  // rarity
  // make P2 appear after P1 etc.

  // power
  if (b.power !== undefined && a.power !== undefined && b.power !== a.power) {
    try {
      let bp = parseInt(b.power?.toString() ?? "0");
      let ap = parseInt(a.power?.toString() ?? "0");
      if (isNaN(bp)) {
        bp = 0;
      }
      if (isNaN(ap)) {
        ap = 0;
      }
      return ap - bp; // Compare as numbers
    } catch (e) {
      console.error(b, a, b.power, a.power);
      throw e;
    }
  }

  // this slows it down a lot
  // compare name of base rarity card. This allows for cards to be grouped by their number_id
  let aName = a.name;
  if (a.id.includes("_p")) {
    const baseCardA = getCardData(a.number)?.name;
    aName = baseCardA || a.name;
  }
  let bName = b.name;
  if (a.id.includes("_p")) {
    const baseCardB = getCardData(a.number)?.name;
    bName = baseCardB || b.name;
  }

  if (aName !== bName) {
    return aName.localeCompare(bName);
  }

  // number
  if (a.number !== b.number) {
    return a.number.localeCompare(b.number);
  }

  return a.id.localeCompare(b.id);
}
